import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/tokens.css';
import './styles/tokens-aliases.css';
import './styles/y-carousel.css';
import './styles/bootstrap-overrides.css';
import './styles/components/toasts.css';
import './index.css';
import App from './App';
import { initDesignMode } from './utils/designMode';
import { SkinProvider } from './styles/SkinProvider';

// Initialize design mode (brand/density and design v2 flag via query/localStorage)
initDesignMode();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <SkinProvider>
        <App />
      </SkinProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// Register tile caching service worker (optional)
try {
  const enableSw = (process.env.REACT_APP_ENABLE_TILE_SW || 'true') !== 'false';
  if (enableSw && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/tiles-sw.js').catch(() => {});
    });
  }
} catch (_) {}